import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import { useTranslate } from 'react-admin';
import { Paper, Box, InputBase, Typography, Divider } from '@material-ui/core';
import Checkbox from '../checkbox'
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import { RECEIVER_TYPE } from '../utils';
import { cloneDeep } from 'lodash';
import icSearch from '../assets/icons/grayscale-3-search.png';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 'auto',
    },
    textSearch: {
        fontFamily: "UniviaPro-Book",
        fontSize: "11px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: "#88898c",
        '&::placeholder': {
            color: '#88898c',
            opacity: 1
        }
    },
    list: {
        height: 255,
        backgroundColor: theme.palette.background.paper,
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            width: '2.8px !important',
            height: "5px",
            borderRadius: "4px",
            backgroundColor: ' #c1e5fa'
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 10px white',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#c1e5fa',
            borderRadius: '10px'
        }
    },
    paper: {
        display: 'flex',
        justifyItems: 'center',
        height: 255,
        width: 250,
        boxShadow: 'none'
    },
    button: {
        margin: theme.spacing(0.5, 0),
    },
    clusterText: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 2.18,
        letterSpacing: "0.11px",
        color: "#4f5064",
    },
    NoRecipientsSelected: {
        paddingBottom: '2px',
        whiteSpace: 'nowrap',
        fontFamily: "UniviaPro-Medium",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#88898c",
    },
    iconSearch: {
        border: "solid 0px #b4b5bd",
    },
    borderSearch: {
        borderRadius: "8.1px",
        border: "solid 0.8px #f1f2f4",
        backgroundColor: "#f7f7f7",
    },
}));

const FilterInput = ({ onChangeValue, value, name }) => {
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );
    const classes = useStyles();

    return (
        <Box width='100%' display='flex' className={classes.borderSearch}>
            <img src={icSearch} className={classes.iconSearch} width={15} height={15} style={{ margin: 'auto 2px auto 5px' }}></img>
            <InputBase
                fullWidth={true}
                placeholder={name}
                inputProps={{
                    'aria-label': 'search',
                    className: classes.textSearch
                }}
                onChange={onChangeValue}
                value={value}
                style={{ width: '180px' }}
            />
        </Box>
    )
}

export default function TransferList({ setRight, right, receiver, left, setLeft, checkedSwitch, setCheckedSwitch, start, oldLeft }) {
    const translate = useTranslate();
    const classes = useStyles();
    const [cloneData, setCloneData] = useState([]);
    const [checked, setChecked] = useState([]);
    const [filter, setFilter] = useState('');
    const [leftFilter, setLeftFilter] = useState(left.filter(value => right.findIndex(element => element.id === value.id) < 0));

    const onChangeFilter = (event) => {
        setFilter(event.target.value)
        setLeftFilter(left.filter(value => value.name.toUpperCase().search(event.target.value.toUpperCase()) > -1
            && right.findIndex(element => element.id === value.id) < 0))
    }

    const handleToggle = (value, style) => () => {
        const temps = right.slice()
        const tempsfilters = leftFilter.slice()
        if (style === 'left') {
            if (tempsfilters.length === 1)
                setFilter('')
            const index = tempsfilters.findIndex(element => element.id === value.id);
            tempsfilters.splice(index, 1)
            setLeftFilter(tempsfilters)
            temps.push(value)
            setRight(temps)
            const newChecked = [...checked];
            newChecked.push(value);
            setChecked(newChecked);
        }
        else {
            const index = right.findIndex(element => element.id === value.id);
            temps.splice(index, 1)
            setRight(temps)
            tempsfilters.push(value)
            setLeftFilter(tempsfilters)
            const newChecked = [...checked];
            newChecked.push(value);
            setChecked(newChecked);
        }

        if (filter === '' && tempsfilters.length === 0)
            setCheckedSwitch(true)
        else
            setCheckedSwitch(false)

    };

    useEffect(() => {
        if (left) {
            setLeftFilter(left.filter(value => value.name.toUpperCase().search(filter.toUpperCase()) > -1
                && right.findIndex(element => element.id === value.id) < 0))
            if (oldLeft) {
                const clone = cloneDeep(oldLeft)
                setCloneData(clone)
            }
            else {
                const clone = cloneDeep(left)
                setCloneData(clone)
            }
        }
    }, [left]);

    useEffect(() => {
        if (start === false) {
            if (left.length > 0) {
                setRight(cloneData)
                setLeft([])
                setLeftFilter([])
            } else {
                setRight([])
                setLeft(cloneData)
                setLeftFilter(cloneData)
                setFilter('')
            }
        }
    }, [checkedSwitch]);

    useEffect(() => {
        if (filter === '') {
            setLeftFilter(left.filter(value => value.name.toUpperCase().search(filter.toUpperCase()) > -1
                && right.findIndex(element => element.id === value.id) < 0))
        }
    }, [filter]);

    if (!left) return null

    const getText = () => {
        if (!receiver) return '';
        switch (receiver) {
            case RECEIVER_TYPE.ENTITY:
                return translate(`resources.messages.Entity`)
            case RECEIVER_TYPE.GROUP:
                return translate(`resources.messages.Group`)
            case RECEIVER_TYPE.CLUSTER:
                return translate(`resources.messages.Cluster`)
            case RECEIVER_TYPE.INDIVIDUALS:
                return translate(`resources.messages.Room`)
            case RECEIVER_TYPE.USER:
                return translate(`resources.messages.User`)
        }
    }

    const customList = (items, style) => {
        return (
            <Box className={classes.list} >
                <Paper className={classes.paper}>
                    <Box width='100%'>
                        {style === 'left' && <Box p={1}>
                            <FilterInput
                                onChangeValue={onChangeFilter}
                                value={filter}
                                name={translate(`resources.alarm.search`) + getText().toLowerCase()} />
                        </Box>}
                        {style === "left" && <Divider />}
                        <List component="nav" disablePadding>
                            {items.map((value, index) => (
                                <React.Fragment key={index}>
                                    <Box display="flex" alignItems="center" key={index} onClick={handleToggle(value, style)}>
                                        <Checkbox
                                            checked={style === 'right'}
                                            color='primary'
                                        />
                                        <Typography className={classes.clusterText} >{value.name}</Typography>
                                    </Box>
                                    <Divider />
                                </React.Fragment>
                            ))}
                        </List>
                    </Box>
                </Paper>
            </Box >
        )
    };

    return (
        <Box>
            <Box display='flex' justifyContent='flex-start'>
                <Box mr={2.5}>
                    {customList(leftFilter, 'left')}
                </Box>
                <Box className={classes.list} style={{ width: 253 }}>
                    {
                        right.length > 0 ?
                            <Box flex="1">{customList(right, "right")}</Box> :
                            <Box flex="1">
                                <List component="div" disablePadding >
                                    <Typography style={{ textAlign: 'center', paddingTop: "120px" }} className={classes.NoRecipientsSelected}>{translate(`resources.alarm.Nodata`)}</Typography>
                                </List>
                            </Box>
                    }
                </Box>
            </Box>
        </Box>
    );
}